$(document).ready(function(){
	var $search_toggle = $('.o-header__search-toggle'),
		$search_bar    = $('.o-search-bar'),
		$close_button  = $('.o-search-bar__close-button');

	// Search Form Toggle
	$search_toggle.on('click', function() {
		$search_bar.slideToggle(300);
	});

	// Search Form Close Button

	$close_button.on('click', function() {
		$search_bar.slideUp(300);
	});
});

$('.o-search-results__table-header').wrap('<div></div>');